import axios from '@/core/axios'
import { ShippingAddressDto } from '@/domain/shared/dtos/shipping-address.dto'
import { WrapResponse } from '@/shared/types/axios'
import { Customer } from 'stoux-shared-types/models/customer'

import { UpdateCustomerDto } from '../dtos/update-customer.dto'
import { UpdateShippingAddressDto } from '../dtos/update-shipping-address.dto'

export class CustomerRepository {
    public async updateCustomer(dto: UpdateCustomerDto): Promise<Customer> {
        const { data } = await axios.post<WrapResponse<'customer', Customer>>(
            '/customers/me',
            dto,
        )
        return data.customer
    }

    public async addShippingAddress(
        dto: ShippingAddressDto,
    ): Promise<Customer> {
        const { data } = await axios.post<WrapResponse<'customer', Customer>>(
            '/customers/me/addresses',
            {
                address: dto,
            },
        )
        return data.customer
    }

    public async updateShippingAddress({
        address_id,
        ...dto
    }: UpdateShippingAddressDto): Promise<Customer> {
        const { data } = await axios.post<WrapResponse<'customer', Customer>>(
            `/customers/me/addresses/${address_id}`,
            dto,
        )
        return data.customer
    }
}
